import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'

export interface CityDistrict {
  city: string;
  district: string[];
}

export const useViewDataStore = create(
  persist(
    () => ({
      activeUsers: '0',
      screenPageViews: '0',
      lastViewUpdate: new Date(1990, 1, 1),
      lastCityDistrictUpdate: new Date(1990, 1, 1),
      cityDistricts: [] as CityDistrict[],
      afterLoginAction: '',
      afterLoginActionParameter: '',
      messageAfterRedirect: '',
    }),
    {
      name: 'gd-view-data-storage',
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);


